import { Icon, Label, Segment } from "semantic-ui-react";

import React from "react";

import Flex from "astrid-components/lib/components/Layout/Flex";
import { updateDocument } from "astrid-firestore/src/helpers";

import DiscussionChannelUserImages from "../../../../discussion/components/DiscussionChannelList/components/DiscussionChannelUserImages";
import { setDiscussion } from "../../../../discussion/state/discussion";
import truncateString from "../../../../ui/utils/truncateString";

function capitalizeFirstLetter(name) {
	return String(name).charAt(0).toUpperCase() + String(name).slice(1);
}

export default function DiscussionFeedListItem({ channel, comment, lastCommentSender }) {
	const onResolve = (e) => {
		e.stopPropagation();
		return updateDocument((comment || channel).ref, { needsAttention: false });
	};

	return (
		<Segment
			vertical
			style={{ padding: 0, cursor: "pointer" }}
			onClick={() => setDiscussion({ isOpen: true, channelId: channel.id })}
		>
			<Flex>
				<div style={{ flex: 1, padding: 15 }} className="discussionsFeedListItem">
					<Flex justifyContent="flex-start" gap={10}>
						<DiscussionChannelUserImages users={comment ? [comment.createdBy] : channel.users} />

						<div>
							<div style={{ margin: 0, opacity: 0.6 }}>
								{truncateString(channel.subject.name, 40)} /
								<Icon name="hashtag" style={{ opacity: 0.4, fontSize: "0.9em", marginRight: 2 }} />
								{capitalizeFirstLetter(channel.name)}
							</div>

							{lastCommentSender && (
								<div style={{ overflow: "hidden" }}>{`${lastCommentSender}: ${truncateString(
									channel.lastComment.text,
									35,
								)}`}</div>
							)}

							{comment && (
								<div style={{ overflow: "hidden" }}>
									<Icon name="fire" color="orange" />
									{truncateString(comment.text, 60)}
								</div>
							)}

							{comment?.attachments?.map((a) => (
								<div key={a.url} style={{ marginTop: 3 }}>
									<Label basic size="tiny">
										{a.name}
									</Label>
								</div>
							))}
						</div>
					</Flex>
				</div>

				<div
					style={{
						alignSelf: "stretch",
						width: 1,
						flexShrink: 0,
						flexGrow: 0,
						background: "rgba(34, 36, 38, 0.15)",
					}}
				/>

				<button
					type="button"
					className="discussionsFeedListItem"
					style={{
						alignSelf: "stretch",
						display: "flex",
						alignItems: "center",
						padding: "0 12px 0 10px",
						border: "none",
						background: "none",
						color: "inherit",
						cursor: "pointer",
					}}
					onClick={onResolve}
				>
					<Icon name="close" style={{ fontSize: 15, margin: 0 }} />
				</button>
			</Flex>
		</Segment>
	);
}
